var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M32.25 31.65Q31.8 31.2 31.8 30.55Q31.8 29.9 32.25 29.5L36.25 25.5H20.25Q19.6 25.5 19.175 25.075Q18.75 24.65 18.75 24Q18.75 23.35 19.175 22.925Q19.6 22.5 20.25 22.5H36.15L32.1 18.45Q31.7 18.05 31.7 17.425Q31.7 16.8 32.15 16.35Q32.6 15.9 33.225 15.9Q33.85 15.9 34.3 16.35L40.95 23Q41.2 23.25 41.3 23.5Q41.4 23.75 41.4 24.05Q41.4 24.35 41.3 24.6Q41.2 24.85 40.95 25.1L34.35 31.7Q33.95 32.1 33.325 32.1Q32.7 32.1 32.25 31.65ZM9 42Q7.8 42 6.9 41.1Q6 40.2 6 39V9Q6 7.8 6.9 6.9Q7.8 6 9 6H22.05Q22.7 6 23.125 6.425Q23.55 6.85 23.55 7.5Q23.55 8.15 23.125 8.575Q22.7 9 22.05 9H9Q9 9 9 9Q9 9 9 9V39Q9 39 9 39Q9 39 9 39H22.05Q22.7 39 23.125 39.425Q23.55 39.85 23.55 40.5Q23.55 41.15 23.125 41.575Q22.7 42 22.05 42Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.4cfca5836e408105e3bafeb45651cfdd.svg";
export { ForwardRef as ReactComponent };